module.exports = __webpack_public_path__ + "static/img/getInvitationDepositRewardsBg.75688ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/getInvitationDepositRewardsBg.png
// module id = tGmX
// module chunks = 0